import React, { useState } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { bookAPI } from '../../../../utils/api';

export default function BookCreate({ onClose, onSubmit, book = null }) {
  const [form, setForm] = useState({
    book_code:           book?.book_code           || '',
    name:                book?.name                || '',
    medium:              book?.medium              || '',
    price:               book?.price               || '',
    pages_first_jacket:  book?.pages_first_jacket  || '',
    pages_second_jacket: book?.pages_second_jacket || '',
    title_pages:         book?.title_pages         || '',
    total_pages:         book?.total_pages         || '',
    color_scheme:        book?.color_scheme        || '',
    size:                book?.size                || '',
    binding:             book?.binding             || '',
  });
  const [loading, setLoading] = useState(false);

  const set = (field) => (e) => {
    const val = e.target.value;
    setForm(prev => {
      const next = { ...prev, [field]: val };
      if (['pages_first_jacket', 'pages_second_jacket', 'title_pages'].includes(field)) {
        const n = v => Number(v) || 0;
        const total = n(next.pages_first_jacket) + n(next.pages_second_jacket) + n(next.title_pages);
        next.total_pages = total || '';
      }
      return next;
    });
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      Swal.fire({ icon: 'error', title: 'Validation', text: 'Book name is required' });
      return;
    }
    setLoading(true);
    try {
      const payload = {
        book_code:           form.book_code           || null,
        name:                form.name,
        medium:              form.medium              || null,
        price:               form.price               ? Number(form.price)               : null,
        pages_first_jacket:  form.pages_first_jacket  ? Number(form.pages_first_jacket)  : null,
        pages_second_jacket: form.pages_second_jacket ? Number(form.pages_second_jacket) : null,
        title_pages:         form.title_pages         ? Number(form.title_pages)         : null,
        total_pages:         form.total_pages         ? Number(form.total_pages)         : null,
        color_scheme:        form.color_scheme        || null,
        size:                form.size                || null,
        binding:             form.binding             || null,
      };
      if (book?.id) {
        await bookAPI.update(book.id, payload);
      } else {
        await bookAPI.create(payload);
      }
      onSubmit && onSubmit();
      Swal.fire({ icon: 'success', title: book?.id ? 'Book updated' : 'Book created', timer: 1800, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <div className="eduss-global-modal-field-grid">
        <div className="eduss-global-modal-field">
          <label>Book Code</label>
          <input value={form.book_code} onChange={set('book_code')} placeholder="e.g. 25-26/BOOK-01" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Book Name *</label>
          <input value={form.name} onChange={set('name')} placeholder="Enter book title" required />
        </div>
        <div className="eduss-global-modal-field">
          <label>Medium</label>
          <input value={form.medium} onChange={set('medium')} placeholder="e.g. Sindhi, Urdu, English" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Unit Price (Rs.)</label>
          <input type="number" step="0.01" min="0" value={form.price} onChange={set('price')} placeholder="0.00" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Pages — 1st Jacket</label>
          <input type="number" min="0" value={form.pages_first_jacket} onChange={set('pages_first_jacket')} placeholder="0" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Pages — 2nd Jacket</label>
          <input type="number" min="0" value={form.pages_second_jacket} onChange={set('pages_second_jacket')} placeholder="0" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Title Pages</label>
          <input type="number" min="0" value={form.title_pages} onChange={set('title_pages')} placeholder="0" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Total Pages (auto-calculated)</label>
          <input type="number" value={form.total_pages} readOnly tabIndex={-1}
            style={{ background: '#f0f4f8', cursor: 'not-allowed', color: '#64748b' }} />
        </div>
        <div className="eduss-global-modal-field">
          <label>Color Scheme</label>
          <input value={form.color_scheme} onChange={set('color_scheme')} placeholder="e.g. CMYK, 4-color" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Size</label>
          <input value={form.size} onChange={set('size')} placeholder="e.g. 20x30/8" />
        </div>
        <div className="eduss-global-modal-field">
          <label>Binding</label>
          <input value={form.binding} onChange={set('binding')} placeholder="e.g. Hot Glue, Saddle Stitch" />
        </div>
      </div>

      <div className="eduss-global-modal-actions">
        <button type="button" className="eduss-global-modal-btn cancel" onClick={onClose}>
          <FaTimes /> Cancel
        </button>
        <button type="submit" className="eduss-global-modal-btn save" disabled={loading}>
          <FaSave /> {loading ? 'Saving…' : book?.id ? 'Update Book' : 'Create Book'}
        </button>
      </div>
    </form>
  );
}
